module.exports = __webpack_public_path__ + "static/media/umbrella-navy-blue.d54298ae.svg";